var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SVGIcon, SVGIconGroup, SVGIconPath } from '../../components/SVGIcon';
var FlashIconShape = React.createElement(SVGIconGroup, null, React.createElement(SVGIconPath, {
  d: "M16.5845941,8.66762117 L13.1674382,8.66762117 L16.937978,2.63592437 C17.0173805,2.50754034 17.0211459,2.34625397 16.9478213,2.21430431 C16.8744967,2.08235466 16.7355479,2.00037477 16.5845941,2 L9.91697292,2 C9.72570784,2 9.55903453,2.13029858 9.51274838,2.31587855 L7.01239044,12.3173103 C6.98135051,12.441762 7.00935024,12.5735742 7.08829951,12.6746619 C7.16724877,12.7757495 7.28835083,12.834849 7.41661498,12.8348844 L10.2045141,12.8348844 L7.84834345,21.475288 C7.79436863,21.6725126 7.89146184,21.8797624 8.07754293,21.9645247 C8.2638144,22.0458426 8.48158927,21.9836212 8.59678393,21.8161701 L16.9313104,9.31438043 C17.015936,9.18654665 17.0235391,9.02257077 16.9511057,8.88745463 C16.8786723,8.7523385 16.7379006,8.66790372 16.5845941,8.66762117 Z"
}));
export var FlashIcon = function FlashIcon(props) {
  var className = props.className,
      restProps = __rest(props, ["className"]);

  return React.createElement(SVGIcon, Object.assign({}, restProps, {
    className: "FlashIcon ".concat(className || '')
  }), FlashIconShape);
};